import React from 'react';
import { Image } from 'react-konva';
import WithCursorPointer from 'components/canvas/components/with-pointer-cursor';
import useImage from 'use-image';
import { isMobile } from 'react-device-detect';
import { KonvaEventObject } from 'konva/lib/Node';

export interface IconProps {
  width: number;
  height: number;
  src: any;
  onError?: Function;
  onClick?: (event: KonvaEventObject<MouseEvent>) => void;
  onMouseOver?: (event: KonvaEventObject<MouseEvent>) => void;
  onMouseOut?: (event: KonvaEventObject<MouseEvent>) => void;
  x?: number;
  y?: number;
}

const defaultProps = {
  width: 26,
  height: 26,
  offsetX: 25,
  y: 16,
};

function Icon({ src, ...props }: IconProps) {
  const [image] = useImage(src);

  function onClick(event) {
    event.cancelBubble = true;
    props.onClick && props.onClick(event);
  }

  const Wrapper = props.onClick ? WithCursorPointer : React.Fragment;

  return (
    <Wrapper>
      <Image
        image={image}
        hitStrokeWidth={props.width}
        {...props}
        {...{
          [isMobile ? 'onTap' : 'onClick']: onClick,
        }}
      />
    </Wrapper>
  );
}

Icon.defaultProps = defaultProps;

export default Icon;
